import { memo, FC, SVGProps } from "react"

export const CloseIcon: FC<SVGProps<SVGSVGElement>> = memo((props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M15 5L5 15" />
    <path d="M5 5L15 15" />
  </svg>
))
export default CloseIcon
